export default __webpack_public_path__ + "static/media/xsl.f5f70598.svg";